import { css } from '@emotion/core'
import * as MQ from 'styles/media-queries'

export const container = css`
  display: flex;

  ${MQ.PHONES} {
    flex-wrap: wrap;
  }
`

export const section = css`
  ${MQ.PHONES} {
    width: 100vw;
  }
`

export const main = css`
  flex: 5;
  width: 100%;
  ${MQ.PHONES} {
    max-width: 100vw;
  }
`
